import React from "react";
import Select from "../select";

const NoOfCities = ({ onChangeHandler, cities, formValues, index,showPlaceholder, item, formValuesLength }) => {
  return (
    <div className="grid lg:grid-cols-3 smAndMd:gap-2">
      <Select
        disabled={!(item?.status === "Unsubmitted" && index === 0 && formValuesLength === 1)}
        options={cities}
        label={'From City'}
        labelAttri={'cityName'}
        valueAttri={'cityId'}
        onChange={(e => {
          onChangeHandler(e,index)
        })}
        value={showPlaceholder ? null : formValues?.fromCityId}
        name={'fromCityId'}
        placeholder={showPlaceholder ? formValues?.fromCityName : null}
        //   error={errors.toCityId}
      />

      <Select
        disabled={showPlaceholder || index < formValuesLength - 1}
        options={cities}
        label={'To City'}
        labelAttri={'cityName'}
        valueAttri={'cityId'}
        onChange={(e => {
          onChangeHandler(e,index)
        })}
        value={showPlaceholder ? null : formValues?.toCityId}
        name={'toCityId'}
        placeholder={showPlaceholder ? formValues?.toCityName : null}
      />
 <div className="relative h-12 mt-3 mx-2">
        <input
          name="distance"
          type="text"
          value={formValues?.distanceEntered}
          className="cursor-not-allowed bg-gray-100 peer h-12 leading-none flex items-center text-secondary font-medium text-baseMd border border-[#AAAAAA] focus:outline-none rounded px-3 pt-4 pb-2 w-full" /* pt-6 pb-2 + flex centers value; leading-none prevents extra line-height */
          placeholder="Distance"
          id="category-input"
          disabled
        />
        <label
          htmlFor="category-input"
          className="absolute left-3 pointer-events-none bg-white px-1 text-sm text-[#AAAAAA] transition-all duration-200 ease-in-out
      peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-base peer-placeholder-shown:-translate-y-1/2
      peer-focus:top-0 peer-focus:text-sm peer-focus:translate-y-0 peer-focus:scale-75
      peer-not-placeholder-shown:top-0 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:translate-y-0 peer-not-placeholder-shown:scale-75"
        >
          Distance
        </label>
      </div>
    </div>
  );
};

export default NoOfCities;
